
import React from 'react';

interface TestItem {
  text: string;
  icon: React.ReactNode;
  animation: any;
}

interface TestAreaProps {
  icon: React.ReactNode;
  title: string;
  items: TestItem[];
  index: number;
}

const TestArea: React.FC<TestAreaProps> = ({ icon, title, items, index }) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 w-full">
      <div className="flex items-center mb-4">
        {icon}
        <h3 className="text-xl font-semibold text-gray-900 ml-3">
          {title}
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((item, itemIndex) => (
          <div key={itemIndex} className="flex items-center text-gray-600 text-sm">
            <div className="mr-3 flex-shrink-0">
              {item.icon}
            </div>
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestArea;
